import { userReducer } from './user'
import { todoReducer } from './todo'

export const reducers = {
  userReducer,
  todoReducer
}
